var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZengo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_11640_1714)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11640_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9507 22.4724C21.8512 22.1033 22.2265 22.7122 21.6709 23.4258C20.2425 25.2604 18.031 29.1342 20.8207 30.8616C22.0681 31.6342 23.9321 31.0676 25.4976 30.5473L25.7487 30.4634C26.1623 30.3253 26.5507 30.196 26.8954 30.1029C29.1092 29.5049 31.445 28.9353 33.7365 29.42C36.3689 29.9765 38.1539 32.616 37.8061 35.2991C37.4609 37.9614 35.0861 39.8794 32.4345 39.8794H16.256C13.1153 39.9418 10.9366 37.6622 10.7051 34.9636C10.6652 34.4993 10.6793 34.0242 10.7513 33.5485C11.2217 30.4547 12.977 27.9413 15.1416 25.8233C16.5384 24.4567 19.0549 23.0511 20.913 22.4838C20.9254 22.4802 20.9383 22.4773 20.9507 22.4724ZM31.7439 8.02823C34.8845 7.96583 37.0636 10.2455 37.2947 12.9441C37.3347 13.4083 37.3209 13.8836 37.2485 14.3591C36.7783 17.4528 35.0229 19.9664 32.8581 22.0844C31.4614 23.4509 28.9452 24.8565 27.0867 25.4238C27.0745 25.4274 27.0616 25.4305 27.0492 25.4353C26.1487 25.8044 25.7734 25.1954 26.329 24.4818C27.7574 22.6473 29.9689 18.7734 27.1794 17.0461C25.5272 16.0229 22.7938 17.3484 21.1049 17.8048C18.8907 18.4027 16.5551 18.9724 14.2635 18.4876C11.6311 17.9311 9.84587 15.2916 10.1938 12.6086C10.539 9.94621 12.9138 8.02823 15.5654 8.02823H31.7439Z",
    fill: "url(#paint1_linear_11640_1714)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11640_1714",
    x: 10.1505,
    y: 8.02698,
    width: 27.6989,
    height: 32.8538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.811765 0 0 0 0 0.780392 0 0 0 0.677133 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11640_1714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11640_1714",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 47.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999087,
    stopColor: "#E6F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11640_1714",
    x1: 11.9815,
    y1: 9.17719,
    x2: 37.4207,
    y2: 39.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FF4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CFC7",
    stopOpacity: 0.677133
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZengo);
export default __webpack_public_path__ + "static/media/zengo.c02829351a3fff692cf9da187a1ab195.svg";
export { ForwardRef as ReactComponent };